/* External dependencies */
import { applyMiddleware, combineReducers, createStore as createReduxStore, Store } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
import { combineEpics, createEpicMiddleware } from 'redux-observable';

/* Local dependencies */
import getDevices from '../components/devices/getDevices/redux/reducer';
import { authReducer } from '../components/webapp/auth/redux/reducer';
import {
  signUpEpic,
  signUpVerificationCode,
  signInEpic,
  forgotPasswordEpic,
  confirmPasswordEpic,
  initialClientEpic,
  signOutEpic,
} from '../components/webapp/auth/redux/epics/epics';
import { authEpicsReducer } from '../components/webapp/auth/redux/epics/reducer';
import { createDeviceReducer } from '../components/devices/createDevice/redux/reducer';
import { createDeviceEpic } from '../components/devices/createDevice/redux/epic';
import getDeviceReducer from '../components/devices/getDevices/redux/reducer';
import { getDeviceEpic } from '../components/devices/getDevices/redux/epic';
import { listDevicesReducer } from '../components/devices/listDevices/redux/reducer';
import { listDevicesEpic } from '../components/devices/listDevices/redux/epic';
import { updateDeviceEpic } from '../components/devices/updateDevice/redux/epic';
import { updateDeviceReducer } from '../components/devices/updateDevice/redux/reducer';
import { deleteDeviceReducer } from '../components/devices/deleteDevice/redux/reducer';
import { deleteDeviceEpic } from '../components/devices/deleteDevice/redux/epic';
import { approveDeviceReducer } from '../components/devices/approveDevice/redux/reducer';
import { approveDeviceEpic } from '../components/devices/approveDevice/redux/epic';
import { getUserReducer } from '../components/users/getUser/redux/reducer';
import { getUserEpic } from '../components/users/getUser/redux/epic';
import { updateUserReducer } from '../components/users/updateUser/redux/reducer';
import { updateUserEpic } from '../components/users/updateUser/redux/epic';
import { listUsersReducer } from '../components/users/listUsers/redux/reducer';
import { listUsersEpic } from '../components/users/listUsers/redux/epic';

const rootEpic = combineEpics<any>(
  signUpEpic,
  initialClientEpic,
  signUpVerificationCode,
  signInEpic,
  forgotPasswordEpic,
  confirmPasswordEpic,
  signOutEpic,
  createDeviceEpic as any,
  getDeviceEpic,
  listDevicesEpic,
  updateDeviceEpic,
  deleteDeviceEpic,
  approveDeviceEpic,
  getUserEpic,
  updateUserEpic,
  listUsersEpic,
);

const rootReducer = combineReducers({
  getDevices,
  auth: authReducer,
  authEpics: authEpicsReducer,
  createDevice: createDeviceReducer,
  getDevice: getDeviceReducer,
  listDevicesReducer,
  updateDeviceReducer,
  deleteDeviceReducer,
  approveDeviceReducer,
  getUserReducer,
  updateUserReducer,
  listUsersReducer,
});

let store;

export function createStore(): Store {
  const epicMiddleware = createEpicMiddleware();
  store = createReduxStore(rootReducer, composeWithDevTools(applyMiddleware(epicMiddleware)));

  epicMiddleware.run(rootEpic);

  return store;
}

export type RootState = ReturnType<typeof store.getState>;
